import React, { useState, useEffect } from 'react';
import { Table } from 'antd';
import CssBaseline from '@material-ui/core/CssBaseline';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import TextEvents from 'app/components/TextEvents';
import Paper from '@material-ui/core/Paper';

import NavMenu from 'components/NavMenu';
import { useStyles, styles } from './ClientProcedureScreenStyles';
import ClientProcedureForm from 'app/components/ClientProcedureForm';
import ClientProcedureTableContainer from 'app/containers/ClientProcedureTableContainer';

import { clientProcedureClear } from 'app/actions/ClientProcedureActions';
import { useDispatch } from 'react-redux';

export default function ClientProcedureScreen(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [pagination, setPagination] = useState({ defaultCurrent: 1, defaultPageSize: 25, pageSize: 25, total: 0, showSizeChanger: true, pageSizeOptions: ['25', '50', '100'], showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`  });
    const [sorter, setSorter] = useState({});
    const [formData, setFormData] = useState({});
    const [filter, setFilter] = useState([]);
    const [visibleForm, isVisibleForm] = useState(false)
    const [idProcedure, setIdProcedure] = useState(0);
    const [nameProcedure, setNameProcedure] = useState(''); 
    const [FiltroClasificacion, setFiltroClasificacion] = useState([]);
    const [FiltroCompany, setFiltroCompany] = useState([]);


    const [idClient, setIdClient] = useState('0');
    useEffect(() => {
        return () => {
            dispatch(clientProcedureClear());
        }
    }, []);

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isCatalog={true} header='Clasificación de Procedimientos de Clientes' isCommunicationStatus={false}/>
            <CssBaseline />
            <div className={`${classes.content}`}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <Link color="inherit" disabled>
                            Catálogos
                        </Link>
                        <TextEvents
                            text="Catálogo de Clasificación de Procedimientos de Clientes"
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>
                </div>
                <Paper className={classes.rootPaper}>
                    <ClientProcedureForm  idProcedure={idProcedure} setIdProcedure={setIdProcedure} nameProcedure={nameProcedure} setNameProcedure={setNameProcedure} idClient={idClient} setIdClient={setIdClient} visibleForm={visibleForm} isVisibleForm={isVisibleForm}  filter={filter} setFilter={setFilter} pagination={pagination} sorter={sorter} formData={formData} setFormData={setFormData} FiltroClasificacion={FiltroClasificacion} setFiltroClasificacion={setFiltroClasificacion} FiltroCompany={FiltroCompany} setFiltroCompany={setFiltroCompany}/>
                    <div style={styles.baseVerticalMargin}>
                        <ClientProcedureTableContainer setIdProcedure={setIdProcedure} setNameProcedure={setNameProcedure} setIdClient={setIdClient} isVisibleForm={isVisibleForm} classes={classes} filter={filter} sorter={sorter} setSorter={setSorter} pagination={pagination} setPagination={setPagination} formData={formData} FiltroClasificacion={FiltroClasificacion} FiltroCompany={FiltroCompany} setFiltroClasificacion={setFiltroClasificacion} setFiltroCompany={setFiltroCompany}>
                            {(params) => {
                                return (
                                    <div>
                                        <Table
                                            loading={params.isLoading}
                                            rowKey={item => String(item.idProcedure)}
                                            columns={params.cols}
                                            dataSource={params.clientProcedure}
                                            onChange={params.handleTableChange}
                                            pagination={pagination}
                                            //scroll={{ y: 700, x: "max-content" }}
                                            scroll={{ x: 'min-content', y: (height - 395) }}
                                            size={"small"}

                                        />
                                    </div>
                                )
                            }}
                        </ClientProcedureTableContainer>
                    </div>
                </Paper>


                </div>
            </div>
         )
}